




















































import Vue from 'vue';
import ReExecuteIntegrationCallRequestViewModel from '../../../../services/v1/viewModel/resource/ReExecuteIntegrationCallRequestViewModel';
import IntegrationCallResourceViewModel from '../../../../services/v1/viewModel/resource/IntegrationCallResourceViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    integrationStatusMessage: (undefined as string | undefined),
    isLoading: false,
    integrationDetail: {} as IntegrationCallResourceViewModel,
    errorResponse: (undefined as string | undefined),
    list: {},
    steps: [] as any[],
    id: Number as unknown | undefined,
  }),
  computed: {
    integrationObjectString: {
      get() {
        let integrationObjectString = this.integrationDetail?.integrationObject ?? 'undefined';
        try {
          if (integrationObjectString.trim().startsWith('{')) {
            integrationObjectString = JSON.stringify(JSON.parse(integrationObjectString), undefined, 2);
          }
        } catch (e) {
          // do nothing
        }
        return integrationObjectString;
      },
      set(value: string) {
        this.integrationDetail.integrationObject = value;
      },
    },
    title() {
      return `${this.integrationDetail.integrationTaskName} (Id: ${this.integrationDetail.id}) ${this.$t('core.page.integrationlog.page.executeAgain')}` ?? this.$t('core.page.integrationlog.integrationDetailTitle');
    },
  },
  async mounted() {
    this.isLoading = true;
    try {
      const { id } = this.$router.currentRoute.params;
      this.id = id;
      const responseIntegrationLog = await this.$service.api.core.integrationCalls.getIntegrationCallById(id as any);
      this.integrationDetail = responseIntegrationLog;
      if (this.integrationDetail.modifierName === null || this.integrationDetail.modifierName === '') {
        this.integrationDetail.modifierName = 'None';
      }
      if (this.integrationDetail.integrationStatusMessage === null || this.integrationDetail.integrationStatusMessage === '') {
        this.integrationDetail.integrationStatusMessage = 'Success';
      }
    } catch (error: any) {
      this.errorResponse = error;
    }
    this.isLoading = false;
  },
  methods: {
    back() {
      this.$router.back();
    },
    async reExecuteIntegrationCall() {
      this.isLoading = true;
      try {
        // check if integrationObject is valid json
        JSON.parse(this.integrationDetail.integrationObject!);
        const req = new ReExecuteIntegrationCallRequestViewModel();
        req.comment = this.integrationStatusMessage!;
        req.payload = this.integrationDetail.integrationObject!;
        await this.$service.api.core.integrationCalls.reExecuteIntegrationCall(this.integrationDetail.id!, req);
        this.$router.push(`/_hostadmin/integrationlog/${this.integrationDetail.id}`);
      } catch (error: any) {
        this.errorResponse = error;
      }
      this.isLoading = false;
    },
  },
});
